/**
 * Zoom Viewer 
 * 
 * HTML5 Canvas Zoom Viewer der als Basis für den Renderer Benötigt wird.
 * 
 * @version   1.0.0
 * @author    Erwin Müller Versandhaus GmbH
 */
(function( window, document ) {
  window.ZoomViewer = ZoomViewer;

  ZoomViewer.prototype = {
    _init: init,
    _onPanStart: onPanStart,
    _onPanning: onPanning,
    _onPanStop: onPanStop,
    _onPinchStart: onPinchStart,
    _onPinching: onPinching,
    _onPinchStop: onPinchStop,
    setSrc: setSrc,
    setZoomDelta: setZoomDelta,
    zoom: zoom,
    zoomIn: zoomIn,
    zoomOut: zoomOut,
    position: position,
    draw: draw,
    animate: animate
  };

  function ZoomViewer (canvas) {
    var self = this;

    self._ctx = canvas.getContext("2d");

    self._cv = document.createElement("canvas");
    self._cvctx = self._cv.getContext("2d");

    self._view = {
      width: canvas.width,
      height: canvas.height,
      position: canvas.getBoundingClientRect(),
      object: canvas
    };

    self._event = {
      touchStartDistance: 0,
      startScale: 0,
      type: false
    };

    self._image = {
      width: 0,
      height: 0,
      pos: [0, 0],
      object: new Image()
    };

    self._zoom = {
      current: 0,
      max: 100,
      min: 10,
      delta: 20
    };

    self._next = {
      zoom: 0,
      pos: [0, 0]
    };

    self._animating = null;

    self._image.object.onload = function () {
      self._image.width = this.width;
      self._image.height = this.height;

      self._init();
    };

    canvas.addEventListener("mousedown", function (e) {
      e.preventDefault();

      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", up);

      self._onPanStart(e.clientX, e.clientY);

      self._event.type = e.type;

      function move (e) {
        e.preventDefault();

        self._onPanning(e.clientX, e.clientY);

        self._event.type = e.type;
      }

      function up (e) {
        e.preventDefault();

        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", up);

        self._onPanStop();

        if (self._event.type === "mousedown") {
          if (self._zoom.current < self._zoom.max) {
            self.zoomIn();
          } else {
            self._next.zoom = self._zoom.min;
            self.animate();
          }
        }

        self._event.type = e.type;
      }
    });

    canvas.addEventListener("touchstart", function (e) {
      e.preventDefault();
      var touches = e.targetTouches;

      if (touches.length === 1) {
        canvas.addEventListener("touchmove", move);
        canvas.addEventListener("touchend", end);
        canvas.addEventListener("touchcancel", end);
        self._onPanStart(touches[0].clientX, touches[0].clientY);
      } else if (touches.length === 2) {
        self._onPinchStart(touches[0].clientX, touches[0].clientY, touches[1].clientX, touches[1].clientY);
      }

      self._event.type = e.type;

      function move (e) {
        e.preventDefault();
        touches = e.targetTouches;

        if (touches.length === 1) {
          self._onPanning(touches[0].clientX, touches[0].clientY);
        } else if (touches.length === 2){
          self._onPinching(touches[0].clientX, touches[0].clientY, touches[1].clientX, touches[1].clientY);
        }

        self._event.type = e.type;
      }

      function end (e) {
        e.preventDefault();
        touches = e.targetTouches;

        if (touches.length === 0) {
          self._view.object.removeEventListener("touchmove", move);
          self._view.object.removeEventListener("touchend", end);
          self._view.object.removeEventListener("touchcancel", end);
          self._onPanStop();
        } else if (touches.length === 1) {
          self._onPinchStop();
        }

        self._event.type = e.type;
      }
    });

    canvas.addEventListener("wheel", function (e) {
      e.preventDefault();

      if (e.deltaY > 0) {
        self._next.zoom = (self._zoom.current - 1 > self._zoom.min) ?
          self._zoom.current - 1 : self._zoom.min;
      } else if (e.deltaY < 0) {
        self._next.zoom = (self._zoom.current + 1 < self._zoom.max) ?
          self._zoom.current + 1 : self._zoom.max;
      }

      self.draw();
    });
  }

  function init () {
    this._zoom.min = 100 / (this._image.width / this._view.width);
    this._next.zoom = (this._zoom.current < this._zoom.min) ?
      this._zoom.min : this._zoom.current;

    this._cv.width = this._image.width;
    this._cv.height = this._image.height;

    this.draw();
  }

  function setSrc (src) {
    if (typeof src === "string") {
      this._image.object.src = src;
    } else {
      this._image.object = src;
      this._image.width = src.width;
      this._image.height = src.height;

      this._init();
    }
  }

  function draw () {
    // update zoom, positions
    this._zoom.current = this._next.zoom;
    this._image.pos[0] = this._next.pos[0];
    this._image.pos[1] = this._next.pos[1];

    var scale = this._zoom.current / 100;

    var width = this._image.width * scale;
    var height = this._image.height * scale;

    var borderX = (width - this._view.width) / (2 * scale);
    var borderY = (height - this._view.height) / (2 * scale);
    var centerX = this._view.width / 2;
    var centerY = this._view.height / 2;

    // check X position
    if (this._image.pos[0] < -borderX) {
      this._image.pos[0] = -borderX;
    } else if (this._image.pos[0] > borderX) {
      this._image.pos[0] = borderX;
    }

    // check Y position
    if (this._image.pos[1] < -borderY) {
      this._image.pos[1] = -borderY;
    } else if (this._image.pos[1] > borderY) {
      this._image.pos[1] = borderY;
    }

    this._ctx.clearRect(0, 0, this._view.width, this._view.height);
    this._ctx.save();
    this._ctx.translate(centerX, centerY);
    this._ctx.scale(scale, scale);
    this._ctx.translate(this._image.pos[0], this._image.pos[1]);

    // prerender if zoom too high
    if (scale < 0.5) {
      this._cvctx.clearRect(0, 0, this._image.width, this._image.height);
      this._cvctx.drawImage(this._image.object,
        0, 0, this._cv.width, this._cv.height);
      this._cvctx.drawImage(this._cv,
        0, 0, this._cv.width, this._cv.height,
        0, 0, this._cv.width / 2, this._cv.height / 2);

      this._ctx.drawImage(this._cv,
        0, 0, this._cv.width / 2, this._cv.height / 2,
        -this._image.width / 2, -this._image.height / 2,
        this._image.width, this._image.height);
    } else {
      this._ctx.drawImage(this._image.object,
        -this._image.width / 2, -this._image.height / 2);
    }

    this._ctx.restore();
  }

  function animate () {
    var self = this;
    var fps = 1000 / 60;
    var duration = 200 / fps;
    var zoom = false, move = false;

    var start = {
      zoom: this._zoom.current,
      pos: [this._image.pos[0], this._image.pos[1]]
    };

    var next = {
      zoom: this._next.zoom,
      pos: [this._next.pos[0], this._next.pos[1]]
    };

    var step = {
      zoom: (this._next.zoom - this._zoom.current) / duration,
      pos: [
        (this._next.pos[0] - this._image.pos[0]) / duration,
        (this._next.pos[1] - this._image.pos[1]) / duration
      ]
    };

    if (self._animating) {
      clearTimeout(self._animating);
      self._animating = null;
    }

    if (next.zoom !== this._zoom.current) {
      zoom = true;
    }

    self._animating = setTimeout(transition, fps);

    function transition () {

      if (self._image.pos[0] !== next.pos[0] ||
      self._image.pos[1] !== next.pos[1]) {
        self._next.pos[0] = self._image.pos[0] + step.pos[0];

        if (next.pos[0] > start.pos[0]) {
          if (self._next.pos[0] > next.pos[0]) self._next.pos[0] = next.pos[0];
        } else if (next.pos[0] < start.pos[0]) {
          if (self._next.pos[0] < next.pos[0]) self._next.pos[0] = next.pos[0];
        }

        self._next.pos[1] = self._image.pos[1] + step.pos[1];

        if (next.pos[1] > start.pos[1]) {
          if (self._next.pos[1] > next.pos[1]) self._next.pos[1] = next.pos[1];
        } else if (next.pos[1] < start.pos[1]) {
          if (self._next.pos[1] < next.pos[1]) self._next.pos[1] = next.pos[1];
        }

        if (zoom === false) {
          self.draw();
          self._animating = setTimeout(transition, fps);
        }
      }

      if (self._zoom.current !== next.zoom) {
        self._next.zoom = self._zoom.current + step.zoom;

        if (next.zoom > start.zoom) {
          if (self._next.zoom > next.zoom) self._next.zoom = next.zoom;
        } else if (next.zoom < start.zoom) {
          if (self._next.zoom < next.zoom) self._next.zoom = next.zoom;
        }
        if (zoom === true) {
          self.draw();
          self._animating = setTimeout(transition, fps);
        }
      }
    }
  }

  function position () {
    if (arguments.length > 0) {
      this._next.pos[0] = arguments[0] || this._image.pos[0];
      this._next.pos[1] = arguments[1] || this._image.pos[1];
    } else {
      return [this._image.pos[0], this._image.pos[1]];
    }
  }

  function setZoomDelta (delta) {
    this._zoom.delta = delta;
  }

  function zoom () {
    if (arguments.length > 0) {
      this._next.zoom = arguments[0];

      if (this._next.zoom < this._zoom.min)
        this._next.zoom = this._zoom.min;
      else if (this._next.zoom > this._zoom.max)
        this._next.zoom = this._zoom.max;
    } else {
      return this._zoom.current;
    }
  }

  function zoomIn () {
    var zoom = this._zoom.current;
    var delta = this._zoom.delta;
    delta -= zoom % delta;
    this.zoom(zoom + delta);
    this.animate();
  }

  function zoomOut () {
    var zoom = this._zoom.current;
    var delta = this._zoom.delta;
    delta = (zoom % delta !== 0) ? zoom % delta : delta;
    this.zoom(zoom - delta);
    this.animate();
  }

  function onPanStart (x, y) {
    var scale = this._zoom.current / 100;
    this._event.status = "pan";
    this._event.panX = x - this._image.pos[0] * scale;
    this._event.panY = y - this._image.pos[1] * scale;
  }

  function onPanning (x, y) {
    var scale = this._zoom.current / 100;

    if(this._event.status === "pan") {
      this._next.pos[0] = (x - this._event.panX) / scale;
      this._next.pos[1] = (y - this._event.panY) / scale;

      this.draw();

      this._event.panX = x - this._image.pos[0] * scale;
      this._event.panY = y - this._image.pos[1] * scale;
    }

  }

  function onPanStop () {
    this._event.status = false;
  }

  function onPinchStart (x1, y1, x2, y2){
    this._event.status = "pinch";

    //calculate distance between touches
    var dx = x2 - x1;
    var dy = y2 - y1;
    this._event.touchStartDistance = Math.sqrt(dx * dx + dy * dy);
    this._event.startScale = this._zoom.current;
  }

  function onPinching (x1, y1, x2, y2){
    if (this._event.status === "pinch") {

      //calculate distance between touches
      var dx = x2 - x1;
      var dy = y2 - y1;
      var touchDistance = Math.sqrt(dx * dx + dy * dy);
      var scalePixelChange = touchDistance - this._event.touchStartDistance;
      this._next.zoom = this._event.startScale + scalePixelChange * 0.1;
      if (this._next.zoom < this._zoom.min)
        this._next.zoom = this._zoom.min;
      else if (this._next.zoom > this._zoom.max)
        this._next.zoom = this._zoom.max;

      this.draw();
    }
  }

  function onPinchStop () {
    this._event.status = false;
  }
})(window, document);